export const Textarea = {
  baseStyle: {
    borderRadius: '0.25rem',
    color: 'black',
    _placeholder: { color: 'gray.900', fontSize: 'sm' },
    _dark: { color: 'white' },
    fontSize: 'sm',
  },
}
